// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.hidden {
  display: none;
}

.header-container {
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  height: 64px;
  color: #0669B3;
  margin-left: 1%;
  margin-right: 1%;
  margin-top: 7px;
  padding: 3px;
  padding-bottom: 10px;
}
.header-container .header-dcsd-icon {
  margin-left: 3px;
}
.header-container .tagline-container {
  margin-left: 10px;
  padding-top: 5px;
}
.header-container .tagline-container .dcsd-tagline1 {
  width: 350px;
  color: #1960BF;
  font-size: 1em;
}
.header-container .tagline-container .dcsd-tagline2 {
  display: flex;
  align-items: center;
  width: 350px;
  color: #1960BF;
  font-size: 0.9em;
}
.header-container .header-left {
  display: flex;
  justify-content: space-between;
}
.header-container .header-left .header-name-container {
  height: 70px;
  display: flex;
  align-items: center;
  padding-top: 10px;
  margin-left: 20px;
}
.header-container .header-right {
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
}
.header-container .header-right .color-override {
  background: #0669B3 !important;
}
.header-container .header-right .nav-button-container {
  height: 70px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.header-container .header-right .nav-button-container .nav-button-links {
  border-radius: 4px;
  padding: 0 15px 0 15px;
  text-transform: lowercase;
}
.header-container .header-right span {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.header-container .header-right span .nav-button-icon {
  padding-left: 10px;
}
.header-container .header-right .nav-button-text {
  color: white;
  font-size: 0.9em;
}

.mobile-hamburger {
  display: none;
}

@media only screen and (max-width: 900px) {
  .mobile-hamburger {
    display: block;
    margin: 5px 25px 0 0;
  }
  .mobile-menu-links a {
    color: #19608f;
    font-size: 0.85em;
    font-weight: 500;
    margin-left: 10px;
  }
  .nav-button-container {
    display: none !important;
  }
  .header-container {
    display: flex;
    justify-content: space-between;
  }
  .header-name-container h5 {
    margin: 0 2.5rem 0 0;
    font-size: 1em;
  }
  .mobile-menu-bold {
    font-weight: bold;
  }
  .helpful-links-dropdown div a {
    text-decoration: none;
  }
  .mobile-list-hamburger {
    margin-left: 16px;
  }
  .mobile-dropdown-icon {
    padding-right: 10px;
  }
  Button a {
    color: #19608f;
    padding-left: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Header.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,aAAA;AAKJ;;AAFA;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,cDmBS;EClBT,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;AAKJ;AAHI;EACI,gBAAA;AAKR;AAHI;EACI,iBAAA;EACA,gBAAA;AAKR;AAJQ;EACI,YAAA;EACA,cAAA;EACA,cAAA;AAMZ;AAJQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAMZ;AAHI;EACI,aAAA;EACA,8BAAA;AAKR;AAJQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AAMZ;AAHI;EACI,aAAA;EACA,8BAAA;EACA,eAAA;AAKR;AAHQ;EACI,8BAAA;AAKZ;AAHQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAKZ;AAHY;EACI,kBAAA;EACA,sBAAA;EACA,yBAAA;AAKhB;AAFQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAIZ;AAFY;EACI,kBAAA;AAIhB;AADQ;EACI,YAAA;EACA,gBAAA;AAGZ;;AAGA;EACI,aAAA;AAAJ;;AAQA;EACI;IACI,cAAA;IACA,oBAAA;EALN;EAQE;IACI,cDjGE;ICkGF,iBAAA;IACA,gBAAA;IACA,iBAAA;EANN;EASE;IACI,wBAAA;EAPN;EAUE;IACI,aAAA;IACA,8BAAA;EARN;EAWE;IACI,oBAAA;IACA,cAAA;EATN;EAYE;IACI,iBAAA;EAVN;EAaE;IACI,qBAAA;EAXN;EAcE;IACI,iBAAA;EAZN;EAeE;IACI,mBAAA;EAbN;EAgBE;IACI,cDtIE;ICuIF,iBAAA;EAdN;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
